<template>
  <div class="yunxiao teacher communicate-details">
    <div class="header van-hairline--bottom">
      <div class="photo-nav" v-if="!studentIfons.photo">
        {{ studentIfons.studentName && studentIfons.studentName.substr(-2) }}
      </div>
      <img class="photo-nav" v-else :src="studentIfons.photo.url" />
      <div class="contain">
        <span>{{ studentIfons.studentName}}</span>的沟通记录
        <div>{{ app.tool.date.getPassTimeStr(detailInfos.createTime)}}</div>
      </div>

      <div 
        v-if="app.permission.op(`${deletePermissionStr} || ${editPermissionStr}`)"
        class="popover-wrap">

        <!-- 
          下面的判断是这个需求https://www.tapd.cn/66041197/prong/stories/view/1166041197001033467
          正式学员进入详情页面，且有opportunityId，表示这是一条线索转入的记录
          不可编辑
        -->
        <van-popover
          class="communicate-details-popover"
          v-if="!(fromPage==='student' && (detailInfos.opportunityId || detailInfos.intentionClueId)) && !hideBtns"
          v-model="showPopover"
          trigger="click"
          placement="bottom-end"
          :offset="[8, 4]"
        >
          <div 
            v-if="app.permission.op(editPermissionStr)"
            @click="gotoEditCommunicate"
            class="communicate-details-popover popover-item ">
            编辑
          </div>
          <div 
            v-if="app.permission.op(deletePermissionStr)" 
            class="communicate-details-popover popover-item "
            @click="deleteCommunication"
            :class="{'van-hairline--top': app.permission.op(editPermissionStr)}"
            style="color:var(--c3)">
            删除
          </div>
          <template #reference>
            <van-icon name="weapp-nav" class="operation-icon" />
          </template>
        </van-popover>
      </div>
    </div>

    <div class="con"  style="margin-right: calc(var(--gap) * 32)">
      <div class="van-ellipsis">
        沟通老师：{{ detailInfos.teacherName }}
      </div>
    </div>
    <div class="con" v-if="fromPage !== 'student' && detailInfos.intentionStudentList">
      关联学员：
      <template v-if="detailInfos.intentionStudentList.length > 0">
        {{ detailInfos.intentionStudentList.map((i) => i.studentName).join("、") }}
      </template>
      <template v-else> -- </template>
    </div>
    <div class="con">
      <span v-if="detailInfos.relation">
        沟通对象：{{detailInfos.relation}}
      </span>
      <span 
        class="tag" 
        :class="{
          'success-status': detailInfos.result === 1,
        }">
        {{
          detailInfos.result == 1 ? "有效" : "无效"
        }}
      </span>
      <span 
        v-if="detailInfos.typeDesc"
        class="tag primary" >
        {{ detailInfos.typeDesc }}
      </span>
      <span 
        v-if="detailInfos.mode"
        class="tag primary" >
        {{ detailInfos.mode }}
      </span>
    </div>
    <vx-mult-input-show :list="detailInfos.content.list" class="content" />
  </div>
</template>

<script>
export default {
  name: 'communicateDetails',
  data () {
    return {
      pageTitle: '沟通记录详情',
      showPopover: false,
      fromPage: this.$vxRoute.query.fromPage,
      communicateId: this.$vxRoute.query.detailId,
      hideBtns: Boolean(this.$vxRoute.query.hideOptBtns),
      detailInfos: {
        intentionStudentList: [],
        content: {
          list: []
        }
      },
    }
  },
  computed: {
    deletePermissionStr (){
      return this.fromPage === 'clue' ? 'all_intention_clue || my_intention_clue' : 'delete_student_communicate'
    },
    editPermissionStr (){
      return this.fromPage === 'clue' ? 'all_intention_clue || my_intention_clue' : 'edit_student_communicate'
    },
    studentIfons () {
      let  { studentName, intentionClueName } = this.detailInfos;
      if (this.fromPage === 'clue') {
        return {studentName: intentionClueName}
      } else {
       return  {studentName: studentName || intentionClueName}
      }
    }
  },
  methods: {
    gotoEditCommunicate() {
      this.showPopover = false;
      if (app.permission.op(this.editPermissionStr)) {
        let  { detailInfos } = this;
        let path = this.fromPage === 'clue' ? '/clueAddCommunication?': '/addStudentCommunication?';
        path += `clueId=${detailInfos.intentionClueId}&`
        path += `detailId=${detailInfos.id}&`
        path += `fromPage=${this.fromPage}`
        this.$router.push(path);
      }
    },
    deleteCommunication() {
      this.showPopover = false;
      this.$dialog
        .confirm({
          message: "确定要删除此条沟通记录么？",
        })
        .then(() => {
          this.$api
            .deleteIntentionCommunicate({
              id: this.detailInfos.id,
            })
            .then((res) => {
              if (res.code === 200) {
                this.$toast.success("删除成功");
                this.fromPage === 'clue' 
                ? app.vue.$emit("refresh-communicate-list") 
                : app.vue.$emit("refresh-student-communicate-list") ;
                this.$router.back();
              }
            })
            .catch(err=>{
              console.log(err)
            });
        })
        .catch(() => {});
    },
    getIntentionCommunicate() {
      
      let api = this.fromPage === 'clue' 
        ? this.$api.getIntentionCommunicate 
        : this.$api.getStudentCommunicate;
      api({
          communicateId: this.$route.query.detailId,
        })
        .then((res) => {
          if (res.code === 200) {
            this.detailInfos = res.data;
          }
        });
    },
  },
  created() {
    if (this.$route.query.detailId) {
      this.getIntentionCommunicate();
    }
    this.$onBus("refresh-student-communicate-details", this.getIntentionCommunicate);
    this.$onBus("add-clue-communicate-success", this.getIntentionCommunicate);
    this.$onBus("deleted-student-communicate-list", ()=>this.$router.back());
  },
  beforeDestroy () {}
}
</script>
<style lang="scss" scoped>
.yunxiao.teacher.communicate-details{
  position: relative;
  margin: 0 0 calc(var(--gap) * 12);
  padding: 0 calc(var(--gap) * 16) calc(var(--gap) * 12) ;
  background: var(--white);
  border-radius: var(--radius-base);
  color: var(--g6);
  font-size:var(--fs-md);
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  .con {
    margin-top: calc(var(--gap) * 12);
    &:first-child {
      margin-top: 0;
    }
    .point {
      color: var(--g8);
    }
    .tag {
      padding: 0 calc(var(--gap) * 4);
      display: inline-block;
      color: var(--g5);
      font-size:var(--fs-sm);
      border-radius: 2px;
      background-color: var(--g2);
      &.success-status{            
        color: var(--c2);            
      }
      &.primary{
        color: var(--c1);
        background-color: rgba(var(--c1-rgb), 0.1);
      }
      &:not(:last-child){
        margin-right: calc(var(--gap) * 8);
      }
    }
  }
  .header{
    display: flex;
    position: relative;
    min-height: calc(var(--w) * 72);
    padding: calc(var(--gap) * 16) calc(var(--gap) * 16) calc(var(--gap) * 16) calc(var(--gap) * 48);
    overflow: hidden;
    .photo-nav {
      margin-left: calc(var(--w) * -48);
      display: flex;
      align-items: center;
      justify-content: center;
      width: calc(var(--w) * 40);
      height: calc(var(--w) * 40);
      font-size: var(--fs-lg);
      line-height: var(--lh-lg);
      color: var(--white);
      background-color: var(--c1);
      border-radius: 50%;
      border: unset;
      outline: unset;
      margin-right: calc(var(--gap) * 8);
    }
    .contain{
      flex: 1;
      >span{
        padding-right: calc(var(--gap) * 4);
        color: var(--g8);
      }
      >div{
        margin-top: calc(var(--gap) * 2);
      }
    }
  }
  .popover-wrap{
    position: absolute;
    height: calc(var(--w) * 16);
    top: 0;
    bottom: 0;
    margin: auto;
    right: 0;
    .operation-icon{
      color: var(--g6);
      font-size:var(--fs-lg);
    }
  }
  .content{
    margin-top: calc(var(--gap) * 12);
  }
}
</style>

<style lang="scss">
.communicate-details-popover{

  &.popover-item{
    margin: 0 calc(var(--gap) * 12);
    width: calc(var(--w) * 96);
    height: calc(var(--w) * 44);
    font-size:var(--fs-md);
    font-weight: 400;
    line-height: 44px;
    text-align: center;
    color: var(--g8);
    cursor: pointer;
  }
}
</style>